<template>
<div>
<!-- Hero -->
    <div class="bg-image overflow-hidden" :style="{'background-image': 'url('+background_image+')'}">
        <div class="bg-primary-dark-op" style="background-color: rgba(14,57,24, 0.8) !important;">
            <div class="content content-narrow content-full">
                <div class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center mt-5 mb-2 text-center text-sm-left">
                    <div class="flex-sm-fill">
                        <h1 class="font-w600 text-white mb-0" data-toggle="appear">Profilo</h1>
                        <h2 class="h4 font-w400 text-white-75 mb-0" data-toggle="appear" data-timeout="250">Tieni la tua pagina sempre aggiornata!</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="content">
        <div class="block">
            <ul class="nav nav-tabs nav-tabs-block align-items-center js-tabs-enabled" data-toggle="tabs" role="tablist">
                <li class="nav-item">
                    <a :class="[selectedSection == 'profilo' ? 'active': '', 'nav-link']" @click="changeSection('profilo')">Profilo</a>
                </li>
                <li class="nav-item">
                    <a :class="[selectedSection == 'fatturazione' ? 'active': '', 'nav-link']" @click="changeSection('fatturazione')">Fatturazione</a>
                </li>
                <li class="nav-item">
                    <a :class="[selectedSection == 'email' ? 'active': '', 'nav-link']" @click="changeSection('email')">Email</a>
                </li>
                <li class="nav-item">
                    <a :class="[selectedSection == 'password' ? 'active': '', 'nav-link']" @click="changeSection('password')">Password</a>
                </li>
                <li class="nav-item">
                    <a :class="[selectedSection == 'sicurezza' ? 'active': '', 'nav-link']" @click="changeSection('sicurezza')">
                        <i class="fa fa-shield-alt mr-1"></i>Sicurezza
                    </a>
                </li>
                <!-- Il bottone matita non serve nel tab Sicurezza né in Profilo -->
                <li v-if="selectedSection !== 'profilo' && selectedSection !== 'sicurezza'" class="nav-item ml-auto">
                    <div class="btn-group btn-group-sm pr-2">
                        <button :disabled="isEdit" @click="editSection" type="button" class="btn btn-primary">
                            <i class="fa fa-fw fa-pencil-alt"></i>
                        </button>
                    </div>
                </li>
            </ul>
            <div class="block-content tab-content">
                <div :class="['tab-pane',selectedSection == 'profilo' ? 'active': '']">
                    <DettaglioProfilo :global_user="user" />
                </div>
                <div :class="['tab-pane',selectedSection == 'fatturazione' ? 'active': '']">
                    <DettaglioFatturazione @callbackReload="callback_reload" :user="user" :isEdit="isEdit" :grades="grades" />
                </div>
                <div :class="['tab-pane',selectedSection == 'email' ? 'active': '']">
                    <DettaglioEmail @callbackReload="callback_reload" :user="user" :isEdit="isEdit" />
                </div>
                <div :class="['tab-pane',selectedSection == 'password' ? 'active': '']">
                    <DettaglioPassword @callbackReload="callback_reload" :isEdit="isEdit" />
                </div>
                <!-- TAB SICUREZZA - nuovo -->
                <div :class="['tab-pane',selectedSection == 'sicurezza' ? 'active': '']">
                    <DettaglioSicurezza @callbackReload="callback_reload" :user="user" />
                </div>
            </div>
        </div>
    </div>
<!-- END Hero -->
</div>
</template>

<script>
import DettaglioProfilo from "../components/Profilo/DettaglioProfilo"
import DettaglioFatturazione from "../components/Profilo/DettaglioFatturazione"
import DettaglioEmail from "../components/Profilo/DettaglioEmail"
import DettaglioPassword from "../components/Profilo/DettaglioPassword"
import DettaglioSicurezza from "../components/Profilo/DettaglioSicurezza"   // ← NUOVO
import UserRepository from "../services/apis/user"

export default {
    data(){
        return {
            background_image: require('@/assets/images/photo3@2x.jpg'),
            selectedSection:'profilo',
            user:null,
            isEdit: false,
            grades:[]
        }
    },
    components: {
        DettaglioProfilo, DettaglioFatturazione, DettaglioEmail, DettaglioPassword,
        DettaglioSicurezza   // ← NUOVO
    },
    methods: {
        changeSection(section){
            this.selectedSection = section
            this.isEdit = false
        },
        editSection(){
            this.isEdit = !this.isEdit
        },
        async callback_reload(){
            this.isEdit = false
            let _user = await UserRepository.get_user_data().catch(() => {})
            console.log('ciao', _user)
            if(_user){
                this.user = _user.data.user
            }
        }
    },
    async created(){
        this.callback_reload()

        let _grades = await UserRepository.grades().catch(() => {})
        
        if(_grades){
            this.grades = _grades.data.data
        }
    }
}
</script>

<style scope>
    .nav-item a {
        cursor: pointer;
    }
</style>